<template>
  <DsIslandsContainer>
    <DsIsland align-center>
      <DsResultBanner
        type="negative"
        size="small"
      >
        <template #title>
          <span v-html="translate('goldkid-reject:photo-ver', title)"></span>
        </template>
        <template #description>
          <span v-html="translate('goldkid-reject:photo-ver:more')"></span>
        </template>
      </DsResultBanner>
    </DsIsland>
    <DsButtonBar sticky>
      <DsButton size="large" @click="repeat">
        {{ translate('goldkid-reject:photo-ver:btn') }}
      </DsButton>
      <DsButton type="ghost" size="large" @click="goHome">
        {{ translate('goldkid-open-failed:btn') }}
      </DsButton>
    </DsButtonBar>
  </DsIslandsContainer>
</template>
<script setup>
import { DsResultBanner, DsIsland, DsIslandsContainer, DsButtonBar, DsButton } from '@ds/vue2';
import { computed } from 'vue'
import useStore from '@/composables/useStore'
const store = useStore()
const goHome = () => {
  window.location.href = process.env.VUE_APP_BASE_URL
}
const repeat = () => {
  store.dispatch('goldkidProcess/component', 'photoVer')
}
const title = computed(()=> {
  return store.getters['goldkidProcess/userData']?.firstName
})

</script>
